import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useHwcIndustryCategories, useHwcIndustryCategoryTemplate } from '../../../../queries';
import { KnownCategories } from '../../../../viewmodels/AppViewModels';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { Modal } from '../../../../web/components/Modal';
import { ISelectBoxOption, SelectBox } from '../../../../web/components/SelectBox';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { useHwcTemplateActions } from './hooks/useHwcTemplateActions';
import { styleSheet } from './styles';

export function ChangeHWCCategoryModal({
	templateId,
	industry,
	categoryName,
	onRequestClose,
}: {
	templateId: string;
	industry: Api.Industry;
	categoryName?: string;
	onRequestClose: () => void;
}) {
	const categoriesQuery = useHwcIndustryCategories({ industry });
	const templateQuery = useHwcIndustryCategoryTemplate({ templateId });
	const [selectedCategoryNameOption, setSelectedCategoryNameOption] = React.useState<ISelectBoxOption<string>>();
	const { templateAddStatusesMutation, templateRemoveStatusesMutation } = useHwcTemplateActions({ industry });
	const mutationsInProgress = templateAddStatusesMutation.isPending || templateRemoveStatusesMutation.isPending;
	const categoryNamesToExclude = [KnownCategories.Featured, 'Archived', 'Uncategorized', categoryName];
	const handleSave = async () => {
		const currentStatus = templateQuery.data.statuses.find(s => s.category === categoryName).status;
		if (categoryName) {
			await templateAddStatusesMutation.mutateAsync({
				statuses: [
					{
						category: selectedCategoryNameOption.value,
						industry,
						status: currentStatus,
					},
				],
				templateId,
			});
			await templateRemoveStatusesMutation.mutateAsync({
				statuses: [
					{
						category: categoryName,
						industry,
						status: currentStatus,
					},
				],
				templateId,
			});
		}
		onRequestClose();
	};
	return (
		<Modal isOpen onRequestClose={onRequestClose} useDefaultHeader shouldCloseOnOverlayClick={!mutationsInProgress}>
			<div className={css(styleSheet.modalTitle)}>Change Category</div>
			<div className={css(styleSheet.inputTitle)}>Select a category to move this campaign to</div>
			{categoriesQuery.data && templateQuery.data ? (
				<>
					<SelectBox
						menuClassName={`${css(styleSheet.dropdownMenu)}`}
						onSelectionChanged={selectedOption => setSelectedCategoryNameOption(selectedOption)}
						options={categoriesQuery.data
							?.map(c => {
								return !categoryNamesToExclude.includes(c.name)
									? {
											title: c.name,
											value: c.name,
										}
									: null;
							})
							.filter(Boolean)}
						selectedOption={selectedCategoryNameOption}
						placeholder={<span>Select a category...</span>}
						triggerClassName={`${css(styleSheet.dropdownTrigger)}`}
					/>
					<div className={css(styleSheet.modalButtons)}>
						<button className={css(baseStyleSheet.ctaButton)} onClick={handleSave} disabled={mutationsInProgress}>
							<span>Change</span>
						</button>
						<button
							className={css(baseStyleSheet.ctaButtonReverse)}
							onClick={onRequestClose}
							disabled={mutationsInProgress}
						>
							<span>Cancel</span>
						</button>
					</div>
				</>
			) : (
				<LoadingSpinner type='small' />
			)}
		</Modal>
	);
}
